import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getConfig } from "../../../utils";

export const signIn = createAsyncThunk('SignIn', async (data) => {
    try {
        const res = await axios({

            method: "post",
            url: getConfig.API_URL + 'user_login',
            data: {
                "email": data?.phone,
                "password": data?.password
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})